import { type TaxFormConfig, type TaxFormType } from "../types";
import { crsEntityConfig } from "./crsEntity.config";
import { crsIndividualConfig } from "./crsIndividual.config";
import { w8benConfig } from "./w8ben.config";
import { w8beneConfig } from "./w8bene.config";
import { w8eciConfig } from "./w8eci.config";
import { w8expConfig } from "./w8exp.config";
import { w8imyConfig } from "./w8imy.config";
import { w9Config } from "./w9.config";

const formRegistry: Record<TaxFormType, TaxFormConfig> = {
  W9: w9Config,
  W8BEN: w8benConfig,
  W8BENE: w8beneConfig,
  W8ECI: w8eciConfig,
  W8EXP: w8expConfig,
  W8IMY: w8imyConfig,
  WITHHOLDING_STATEMENT: w8beneConfig, // TODO: Replace with actual withholding statement config
  CRS_INDIVIDUAL: crsIndividualConfig,
  CRS_ENTITY: crsEntityConfig,
};

export const getTaxFormConfig = (formType: TaxFormType): TaxFormConfig => {
  const config = formRegistry[formType];
  if (!config) {
    throw new Error(`Unknown tax form type: ${formType}`);
  }
  return config;
};

export {
  crsEntityConfig,
  crsIndividualConfig,
  w8benConfig,
  w8beneConfig,
  w8eciConfig,
  w8expConfig,
  w8imyConfig,
  w9Config,
};
